import Vue from 'vue'
import App from './App.vue'

import Vuex from 'vuex'
Vue.use(Vuex)

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import UUID from 'vue-uuid';
Vue.use(UUID);

// // ElementUI
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import router from './router' 

import store from './store'

//axios 全局配置
import './config/axios'

// 本地存储
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true //created computed members from your variable declarations
})

//剪贴板
import VueClipboard  from 'vue-clipboard2'
Vue.use( VueClipboard )



Vue.config.productionTip = false

// 全局过滤器
import * as filters from './assets/js/filters.js'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
